/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LicenseStatusTypes = {
    None: 'None',
    Valid: 'Valid',
    Trial: 'Trial',
    InGracePeriod: 'InGracePeriod',
    Expired: 'Expired'
} as const;
export type LicenseStatusTypes = typeof LicenseStatusTypes[keyof typeof LicenseStatusTypes];


export function LicenseStatusTypesFromJSON(json: any): LicenseStatusTypes {
    return LicenseStatusTypesFromJSONTyped(json, false);
}

export function LicenseStatusTypesFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicenseStatusTypes {
    return json as LicenseStatusTypes;
}

export function LicenseStatusTypesToJSON(value?: LicenseStatusTypes | null): any {
    return value as any;
}

/**
 * Check if a given object implements the LicenseStatusTypes interface.
 */
 export function instanceOfLicenseStatusTypes(value: any): value is LicenseStatusTypes {
    return Object.values(LicenseStatusTypes).includes(value)
}

